import { render, staticRenderFns } from "./RelatorioParaExportacao.vue?vue&type=template&id=891151ac&scoped=true&"
import script from "./RelatorioParaExportacao.vue?vue&type=script&lang=js&"
export * from "./RelatorioParaExportacao.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioParaExportacao.vue?vue&type=style&index=0&id=891151ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891151ac",
  null
  
)

export default component.exports